import { NICmsContentField } from '@icms/core/content';
import { presetColors } from '../../../../../styles/cms.config';
import { defaultImage, defaultImagePng } from 'projects/app-default/src/app/icms.config';
export const FASHION_RECOMMENDATIONS_COMPONENT_CONFIG = {
    id: 'fashion-recommendations',
    name: 'Fashion Recommendations',
    tags: ['fashion', 'recommendations', 'colour'],
    fields: [
        <NICmsContentField.IField>{
            key: 'headline',
            type: NICmsContentField.EFieldType.text,
            title: 'Headline',
            default: 'What Suits Your Horse Best?'
        },
        <NICmsContentField.IField>{
            key: 'copy',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy',
            default: 'Here are some of our favourite colour matches. Share yours with us on Instagram @lemieuxproductsofficial'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'slides',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Slides',
            itemName: 'Fashion Slide',
            itemNameField: 'slideTitle',
            required: true,
            fields: [
                <NICmsContentField.IField>{
                    key: 'slideTitle',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Title',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'slideImage',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'slideImageHover',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image Hover',
                    description: 'Visible when user hovers over it on desktops or click on touchy devices'
                },
                <NICmsContentField.IRepeaterField>{
                    key: 'colourSwatches',
                    type: NICmsContentField.EFieldType.repeater,
                    title: 'Colour Swatches',
                    itemName: 'Colour Swatch',
                    itemNameField: 'colourName',
                    required: true,
                    defaultSize: 3,
                    fields: [
                        <NICmsContentField.IField>{
                            key: 'colour',
                            type: NICmsContentField.EFieldType.colorPicker,
                            presetColors,
                            title: 'Colour',
                            required: true,
                            default: '#000000'
                        },
                        <NICmsContentField.IField>{
                            key: 'colourName',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Name',
                            required: true
                        },
                        <NICmsContentField.IField>{
                            key: 'colourLink',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Link'
                        }
                    ]
                }
            ],
            default: [
                {
                    slideTitle: 'Example Collection',
                    slideImage: defaultImagePng,
                    slideImageHover: defaultImage,
                    colourSwatches: [
                        {
                            colour: '#ff3366',
                            colourName: 'Pink',
                            colourLink: '/'
                        },
                        {
                            colour: '#0099cc',
                            colourName: 'Blue',
                            colourLink: '/'
                        },
                        {
                            colour: '#ff9900',
                            colourName: 'Orange',
                            colourLink: '/'
                        }
                    ]
                },
                {
                    slideTitle: 'Example Collection',
                    slideImage: defaultImagePng,
                    slideImageHover: defaultImage,
                    colourSwatches: [
                        {
                            colour: '#66cc33',
                            colourName: 'Green',
                            colourLink: '/'
                        },
                        {
                            colour: '#ffcc00',
                            colourName: 'Yellow',
                            colourLink: '/'
                        }
                    ]
                },
                {
                    slideTitle: 'Example Collection',
                    slideImage: defaultImagePng,
                    slideImageHover: defaultImage,
                    colourSwatches: [
                        {
                            colour: '#68cc33',
                            colourName: 'Green',
                            colourLink: '/'
                        }
                    ]
                }
            ]
        }
    ]
};
